import { HUBSPOT_FORM_API } from '@/constants/constants';

export type HubspotFormField = {
  name: string;
  value: string | File | FormDataEntryValue | null;
};

export type HubspotFormData = {
  fields: HubspotFormField[];
};

class HubspotService {
  /**
   * Submit a form to HubSpot
   * @param formId - HubSpot form ID
   * @param portalId - HubSpot portal ID
   * @param fields - Form fields to submit
   * @returns Promise that resolves when the submission is complete
   */
  async submitForm(formId: string, portalId: string, fields: HubspotFormField[]): Promise<Response> {
    const data: HubspotFormData = { fields };

    const response = await fetch(`${HUBSPOT_FORM_API}/${portalId}/${formId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (!response.ok) {
      throw new Error(`HubSpot submission failed with status: ${response.status}`);
    }

    return response;
  }
}

export default new HubspotService();
